import type { Context, PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';

/**
 * For Series, each Subscribe button will
 * 1. Get User profile from Sailthru
 * 2. Put updated User profile from Sailthru
 * 3. Ensure user is subscribed to Series list
 *
 * If multiple Subscribe buttons were clicked at the same time, step 1-2 could race condition.
 * This context ensure only 1 Subscribe button in the page can clicked at a time.
 */
interface ISubscribeButtonLockContextValue {
    locked: boolean;
    setLocked: (x: boolean) => void;
}

const initialState = {
    locked: false,
    setLocked: () => {},
};

const SubscribeButtonLockContext: Context<ISubscribeButtonLockContextValue> = createContext(initialState);

export const SubscribeButtonLockContextProvider = ({ children }: PropsWithChildren) => {
    const [locked, setLocked] = useState(false);

    return (
        <SubscribeButtonLockContext.Provider value={{ locked, setLocked }}>
            {children}
        </SubscribeButtonLockContext.Provider>
    );
};

export function useSubscribeButtonLockContext(): ISubscribeButtonLockContextValue {
    const context = useContext(SubscribeButtonLockContext);
    if (!context) {
        throw new Error('useSubscribeButtonLockContext must be used within an SubscribeButtonLockContextProvider');
    }
    return context;
}
